import template from './TheHeader.html';
import config from '../../../../configs/config';

export default {
	template,
	data() {
		return {
			isLoggingOut: false,
			picError: false
		};
	},
	methods: {
		getInitials() {
			let name = (this.app.user.name || this.app.user.email || '?').trim();
			let parts = name.split(/[\s._-]+/).filter(Boolean);
			let initials = parts.slice(0, 2).map(p => p[0]).join('');
			return initials.toUpperCase();
		},
		async logout() {
			this.isLoggingOut = true;
			await this.app.logout();
			this.isLoggingOut = false;
		},
		getProfilePicUrl() {
			let endpointBase = config.endpointBase || '';
			return endpointBase + '/api/profile-pic?' + this.app.user.id;
		}
	}
}